import { ConstMap } from '@/utils/ConstMap';

export enum NAVIGATOR_TARGET {
  TOPIC = 'topic',
  TAXONOMY = 'taxonomy',
  CHART = 'chart',
  DASHBOARD = 'dashboard',
  DASHBOARD_FOLDER = 'dashboard_folder',
  MENU = 'menu',
  SETTINGS = 'settings',
}

export const NavigatorTargetNameMap = new ConstMap([
  [NAVIGATOR_TARGET.TOPIC, 'Topic'],
  [NAVIGATOR_TARGET.CHART, 'Chart'],
  [NAVIGATOR_TARGET.DASHBOARD, 'Dashboard'],
  [NAVIGATOR_TARGET.TAXONOMY, 'Taxonomy'],
  [NAVIGATOR_TARGET.DASHBOARD_FOLDER, 'Dashboard Folder'],
  [NAVIGATOR_TARGET.MENU, 'Menu'],
  [NAVIGATOR_TARGET.SETTINGS, 'Settings'],
]);

export type NavigatorBaseItem = {
  target: NAVIGATOR_TARGET;
  alias: string;
  name: string;
  href: string;
  path?: string;
  hidden?: boolean;
};

export type NavigatorSelectItem = NavigatorBaseItem & {
  icon?: React.ReactNode;
};
